import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="grid-bg flex min-h-screen items-center justify-center">
        <div className="h-12 w-12 animate-spin border-2 border-edge border-t-yellow" />
      </div>
    );
  }
  if (!user) return <Navigate to="/signin" replace />;
  return children;
}
